<div class="background-elements">
  <div class="content-background"></div>
  <div class="screen-shadow1"></div>
  <div class="screen-shadow2"></div>
  <div class="football"></div>
  <div class="tennis"></div>
</div>
<ion-content class="w_content w_background" [scrollY]="!isNative">
  <div class="wrapper">
    @if (config.environmentLabel) {
      <div class="development-build-label">{{ config.environmentLabel }}</div>
    }
    <div class="logo">
      <div class="logo-image"></div>

      <h5 class="textWhite ion-text-center">Every Match, More Ways to Win</h5>
    </div>


    <div class="sign-up-wrapper">
      <form class="login-form-form content-column ion-padding" #checkForm="ngForm" (ngSubmit)="checkUserEmail(checkForm)">
        <ion-list class="login-form-list">
          <div class="item-wrapper item-wrapper-with-shadow" [ngClass]="{'is-invalid':userEmail.invalid && userEmail.touched}">
            <ion-item class="login-form-item"  no-lines>
              <ion-label position="stacked">Email</ion-label>
              <ion-input #inputToFocus class="login-form-input reg_login_email_input"
                         data-testid="welcome-email"
                         id="email"
                         type="email"
                         autocomplete="username"
                         (ionFocus)="loadEmailCredential()"
                         [(ngModel)]="account.email"
                         name="email"
                         #userEmail="ngModel"
                         required
                         email
                         pattern="^[^@]+@[^@]+\.[^@]+$"
                         placeholder="Please enter your email"
                         minlength="5">
              </ion-input>
            </ion-item>
          </div>
<!--          {{userEmail.valid}}-->
          <div  class="sign-up-button ion-text-center">
            <button class="popup-button" data-testid="welcome-submit" [disabled]="!userEmail.valid">Sign In / Sign Up</button>
          </div>
        </ion-list>
      </form>

<!--      <form class="login-form-form" #checkForm="ngForm" (ngSubmit)="checkUserEmail(checkForm)" padding>-->
<!--        <ion-list class="login-form-list">-->
<!--          <div class="item-wrapper item-wrapper-with-shadow" [ngClass]="{'is-invalid':userEmail.errors && userEmail.touched}">-->
<!--            <ion-item class="login-form-item"  no-lines>-->
<!--              <ion-label stacked>Email</ion-label>-->
<!--              <ion-input #inputToFocus class="login-form-input reg_login_email_input"-->
<!--                         type="email"-->
<!--                         [(ngModel)]="account.email"-->
<!--                         name="email"-->
<!--                         #userEmail="ngModel"-->
<!--                         required-->
<!--                         email-->
<!--                         pattern="^[^@]+@[^@]+\.[^@]+$"-->
<!--                         placeholder="Please enter your email"-->

<!--                         minlength="5">-->
<!--              </ion-input>-->
<!--              <p >Email not valid</p>-->
<!--            </ion-item>-->
<!--          </div>-->
<!--          <div class="sign-up-button ion-text-center">-->
<!--            <button ion-button="" block class="popup-button" [disabled]="!userEmail.valid">Sign In / Sign Up</button>-->
<!--          </div>-->
<!--        </ion-list>-->
<!--      </form>-->

      <div class="terms-and-conditions-wrapper ion-text-center" >
        <div >
          By signing up you agree to our
        </div>
        <div>
          <a [href]="termsAndConditions"  class="button-link" target="_blank">Terms & Conditions</a> and <a [href]="privacyPolicy" target="_blank"  class="button-link">Privacy policy</a>.
        </div>
      </div>
      <div class="app-version ion-text-center">
        Version {{appVersion.version}} ({{appVersion.build}})
      </div>
    </div>

    <br><br>
    <div class="plus-18-wrapper">
      <ion-row>
        <ion-col size="3">
          <div class="image-18"></div>
        </ion-col>
        <ion-col size="9">
          <div class="text-18" >You must be over 18 and in the UK to signup for Match15.</div>
        </ion-col>
      </ion-row>
    </div>
  </div>
  <app-web-footer></app-web-footer>
</ion-content>
